import React from 'react';
import moment from 'moment';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Button from '@mui/lab/LoadingButton';
import DateTimePicker from '@mui/lab/DateTimePicker'

import { useMutation, useQueryClient } from 'react-query';
import { useForm, Controller } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { updateVacation } from 'api/players';


interface EditVacationDialogInterface extends DialogProps {
        vacationId: number;
        start: string;
        end: string;
}


const EditVactionDialog: React.FC<EditVacationDialogInterface> = (props) => {
    const { playerId } = useParams();

    const queryClient = useQueryClient();

    const { control, handleSubmit, reset, setValue } = useForm({
        defaultValues: {
            start_datetime: null,
            end_datetime: null,
        }
    });

    const updateMutation = useMutation(updateVacation, {
        onSuccess: () => {
            queryClient.invalidateQueries(['player-active-vacation', playerId]);
            props.onClose({}, 'backdropClick');
        }
    });

    const onSubmit = handleSubmit((data: any) => {
        updateMutation.mutate({
            ...data,
            vacationId: props.vacationId,
            start_datetime: data.start_datetime.toISOString(),
            end_datetime: data.end_datetime.toISOString(),
        });
    });

    React.useEffect(() => {
        setValue('start_datetime', moment(props.start));
        setValue('end_datetime', moment(props.end));
    }, [props]);

    return (
        <Dialog {...props} maxWidth="sm" fullWidth>
            <DialogTitle>Редактировать отпуск</DialogTitle>
            <DialogContent>
                <form className="flex flex-col space-y-4 pt-2" onSubmit={onSubmit} noValidate>
                    <Controller
                        name="start_datetime"
                        control={control}
                        render={({ field }) => (
                            <DateTimePicker
                                {...field}
                                renderInput={props => (
                                    <TextField {...props} label="Дата начала" required fullWidth />
                                )}
                            />
                        )}
                    />
                    <Controller
                        name="end_datetime"
                        control={control}
                        render={({ field }) => (
                            <DateTimePicker
                                {...field}
                                renderInput={props => (
                                    <TextField {...props} label="Дата конца" required fullWidth />
                                )}
                            />
                        )}
                    />
                    <div className="pt-4 flex justify-end text-right">
                        <Button
                            type="submit"
                            variant="contained"
                            size="large"
                            loading={updateMutation.isLoading}
                        >Изменить</Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default EditVactionDialog;
